<template>
  <div class="source" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="header">
      <div class="box"></div>
      <div class="headCon">
        <p>当前积分</p>
        <div class="username">{{total}}</div>
      </div>

      <div class="info">
        <img :src="userData.avatar" />
        <p>
          {{userData.username}}
          <b>加入时间:{{userData.createtime}}</b>
        </p>
      </div>
    </div>

    <ul>
      <li v-for="(item,i) in order">
        <h2>{{item.name}}</h2>
        <p>领取时间：{{item.createtime}}</p>
        <div class="point">{{item.c_id > 0 ? '所领取'+item.price+'积分' : '所支出'+item.price+'积分'}}</div>
        <div class="sr" v-if="item.c_id > 0">收入</div>
        <div class="sr" v-if="item.c_id == undefined" style="color:#f00">支出</div>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        order:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        total:[]
      };
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
      this.active = this.$route.query.id;
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getOrder();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },  
      getOrder:function(){
        var that = this;
        var cate_id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/product/userPoint',
          params:{
            user_id:that.userData.id,
            cate_id:cate_id
          }
        }).then(function(response){
          var res = response.data;
          that.order = res.data.rs;
          that.total = res.data.total;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .source{
    max-width:640px;
    background:#f1f1f1;
    margin:0 auto;
    padding-bottom:5px;
  }
  .source .header{
    width: 100%;
    margin: auto; 
    position: relative;
    min-height: 200px;
  }
  .source .header .box { 
    min-height: 200px;
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  .source .header .box::after { 
    width: 140%; 
    height: 196px; 
    position: absolute; 
    left: -20%; 
    top: 0; 
    z-index: 1; 
    content: ''; 
    border-radius: 0 0 50% 50%; 
    background: linear-gradient(#009bff, #004aff);
    border-bottom: 6rpx #f5d872 solid;
  }
  .source .header .headCon{
    position: absolute;
    width: 100%;
    left: 0;
    top: 40%;
    z-index: 99;
    text-align: center;
    transform: translateY(-40%);
  }
  .source .header .headCon p{
    color:#fff;
    font-size:15px;
    letter-spacing: 2px;
    padding-bottom:10px
  }
  .source .header .headCon .username{
    color:#fff;
    font-size:28px;
    letter-spacing: 2px;
    font-weight:bold
  } 

  .source .header .info{
    position: absolute;
    width: 86%;
    left: 7%;
    bottom: -15px;
    z-index: 99;
    background:#fff;
    height:80px;
    border-radius: 8px;
  }
  .source .header .info img{
    float:left;
    width:50px;
    border-radius: 50%;
    margin:15px 10px 0 15px;
  }
  .source .header .info p{
    float:left;
    font-size:18px;
    font-weight:bold;
    width:60%;
    margin-top:15px;
  }
  .source .header .info p b{
    display:block;
    font-weight:normal;
    font-size:14px;
    color:#666;
    padding-top:8px
  }

  .source ul{
    display:block;
    width:86%;
    margin:0 auto;
    margin-top:30px
  }
  .source ul li{
    display:block;
    background:#fff;
    width:100%;
    border-radius: 8px;
    margin-bottom:8px;
    position: relative;
  }
  .source ul li h2{
    font-size:16px;
    padding:15px;
    letter-spacing: 2px;
  }
  .source ul li p{
    font-size:15px;
    padding-left:15px;
    color:#666;
    letter-spacing:1px;
    padding-bottom:15px;
  }
  .source ul li .point{
    font-size:15px;
    padding-left:15px;
    color:#004aff;
    letter-spacing:1px;
    padding-bottom:15px;
    font-weight:bold
  }
  .source ul li .sr{
    position: absolute;
    top:15px;
    right:15px;
    color:green;
    font-size:15px;
    font-weight:bold
  }
</style>